import React from "react";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-black p-6 text-center" data-testid="not-found">
      <Logo size="md" />
      <p className="overline mt-10">404</p>
      <h1 className="font-display text-5xl font-black tracking-tighter text-white mt-3 uppercase">
        Off the <span className="text-brand">map</span>.
      </h1>
      <p className="text-[#a3a3a3] mt-3 max-w-md">
        This itinerary doesn't exist. Let's get you back to the network.
      </p>
      <Link to="/" className="btn-primary mt-8">Take me home</Link>
    </div>
  );
}
